export default [{
  path: 'merchantlist/:leftid/:parent_id',
  name: 'backend_merchantlist',
  component: () => import('@/views/backend/admin/merchant/list/list'),
  meta: {
    tpflag: 'backend',
    title: '商家列表',
  }
},{
  path: 'merchantbank/:leftid/:parent_id',
  name: 'backend_merchantbank',
  component: () => import('@/views/backend/admin/merchant/bank/list'),
  meta: {
    tpflag: 'backend',
    title: '商家账户',
  }
}, {
  path: 'merchantmember/:leftid/:parent_id',
  name: 'backend_merchantmember',
  component: () => import('@/views/backend/admin/merchant/member/list'),
  meta: {
    tpflag: 'backend',
    title: '成员账号',
  }
}, {
  path: 'merchantmembernew/:leftid/:parent_id',
  name: 'backend_merchantmembernew',
  component: () => import('@/views/backend/admin/merchant/member/new'),
  meta: {
    tpflag: 'backend',
    title: '成员账号-新增账号',
  }
}, {
  path: 'merchantwechatauth/:leftid/:parent_id',
  name: 'backend_merchantwechatauth',
  component: () => import('@/views/backend/admin/merchant/member/wechat'),
  meta: {
    tpflag: 'backend',
  }
}, {
  path: 'merchanttransfer/:leftid/:parent_id',
  name: 'backend_merchanttransfer',
  component: () => import('@/views/backend/admin/merchant/transfer/list'),
  meta: {
    tpflag: 'backend',
    title: '商家转让',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_merchant.js